import { type PartialDeep } from 'type-fest';

import { type CanvasElementFrom } from '@blaze-runtime/engine-domain';
import { type BlazeSchema } from '@blaze-shared/schema-domain';

import { type DefinitionMapper } from '../../../ai';
import { toHeightStyle, toWidthStyle } from '../../../ai/models/styles';
import { type CanvasElementDefinition } from '../../../canvas-elements/element-definition';

import { type ButtonDefinition } from './button.definition';

export class ButtonDefinitionMapper implements DefinitionMapper<'button'> {
  readonly type = 'button';

  extract(
    element: CanvasElementFrom<'button'>,
    _schemas: Readonly<Record<string, BlazeSchema>>,
    definition: CanvasElementDefinition<'button'>,
  ): PartialDeep<ButtonDefinition> {
    const content = element.props.content;

    return {
      label: content?.button?.label ?? definition.defaults?.content.button?.label,
      iconName: content?.button?.icon,
      styleName: element.props.styleConfig?.styleName,
      width: toWidthStyle(element.width),
      height: element.height ? toHeightStyle(element.height) : undefined,
    };
  }
}
